export default "__VITE_ASSET__D9BJlD$7__"